var _defs, _g, _g2, _ellipse, _ellipse2, _path, _path2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _rect, _path10, _path11, _path12, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NoDesk",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 399.743,
    height: 354.748,
    viewBox: "0 0 399.743 354.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 337.528,
    height: 332.264,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 325.914,
    height: 380.58,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3669",
    "data-name": "Group 3669",
    transform: "translate(62.216)",
    opacity: 0.496
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3668",
    "data-name": "Group 3668",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4907",
    "data-name": "Path 4907",
    d: "M329.225,175.671c-14.4,55.185-45.391,100.967-83.864,127.475-38.473,27-84.424,34.732-128.734,25.23-44.309-9.662-78.589-32.652-98.192-58.131C-1.168,244.21-6.094,215.686,8.3,182.066c14.4-33.472,45.392-68.421,83.864-101.785C130.64,47.53,176.591,16.364,220.9,4.575c44.31-12.079,78.589.108,98.192,32.437,19.6,31.789,24.529,83.721,10.132,138.659",
    transform: "translate(0 0)",
    fill: "#eff8f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3671",
    "data-name": "Group 3671",
    transform: "translate(0 334.83) rotate(-87)",
    opacity: 0.367,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3670",
    "data-name": "Group 3670",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4908",
    "data-name": "Path 4908",
    d: "M316.416,226.6c-15.113,81.382-45.352,135.724-82.009,149.17-36.691,15.058-80.061-7.307-122.267-37.972a1161.315,1161.315,0,0,1-94.118-77.661C-.949,241.6-5.892,232.85,7.759,219.342c13.658-13.41,43.276-33,80.41-67.633,37.114-33.1,81.9-83.713,125.469-120.784,43.56-37.344,77.36-43.4,95.91-4.143,18.63,37.029,21.957,119.111,6.867,199.814",
    transform: "translate(0 0.001)",
    fill: "#eff8f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(-27.874 -459.693)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 53.5,
    cy: 3,
    rx: 53.5,
    ry: 3,
    transform: "translate(160.874 700.897)",
    opacity: 0.056
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 53.5,
    cy: 3,
    rx: 53.5,
    ry: 3,
    transform: "translate(257.874 700.897)",
    opacity: 0.056
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3648",
    "data-name": "Group 3648",
    transform: "translate(265.852 539.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(82.869 69.212)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M1796.427,1137.773h.928l1.57-95.18h-4.069Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#20c5a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1794.857,1042.593h4.069l-.086,4.514-3.949-2.761Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#20c5a0",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(9.235 69.212)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1520.338,1137.773h.928l1.57-95.18h-4.068Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#0f7961"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M1518.768,1042.593h4.068l-.086,4.514-3.948-2.761Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#0f7961",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M1493.2,1041.082h88.109a.864.864,0,0,0,.864-.864h0a.864.864,0,0,0-.864-.864H1493.2a.864.864,0,0,0-.864.864h0A.864.864,0,0,0,1493.2,1041.082Z",
    transform: "translate(-1490.152 -971.007)",
    fill: "#20c5a0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 49.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M1567.04,1035.675h-28.5a1.338,1.338,0,0,1-1.339-1.338h31.181A1.338,1.338,0,0,1,1567.04,1035.675Z",
    transform: "translate(-1523.047 -1016.803)",
    fill: "#e6e6e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M1545.474,1035.675h-31.346a1.339,1.339,0,0,1-1.339-1.338H1543.9C1544.158,1034.927,1544.469,1035.675,1545.474,1035.675Z",
    transform: "translate(-1505.149 -1016.803)",
    fill: "#f0f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(33.719 17.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M1612.01,1036.546h-1.174a.265.265,0,0,1-.264-.265h0a.264.264,0,0,1,.264-.265h1.174a.265.265,0,0,1,.265.265h0A.265.265,0,0,1,1612.01,1036.546Z",
    transform: "translate(-1610.572 -1036.016)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 0.265,
    cy: 0.265,
    rx: 0.265,
    ry: 0.265,
    transform: "translate(2.14 0)",
    fill: "#bcbec0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M1485.458,968.594h27.662a2.272,2.272,0,0,1,2.048,1.289l7.8,16.245h-31.182l-7.51-15.649A1.315,1.315,0,0,1,1485.458,968.594Z",
    transform: "translate(-1484.141 -968.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M1592.626,968.594h.829a2.271,2.271,0,0,1,2.047,1.289l7.8,16.245h-.828l-7.8-16.245A2.271,2.271,0,0,0,1592.626,968.594Z",
    transform: "translate(-1563.693 -968.594)",
    fill: "#e6e6e7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(147.114 563.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(54.373 41.989)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1029.47,1051.934h25.32l5.611-16.654H1035.08Z",
    transform: "translate(-1022.712 -1035.28)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1037.152,1052.469h21.979l4.471-12.96h-21.978Z",
    transform: "translate(-1027.963 -1038.381)",
    fill: "#20c5a0",
    opacity: 0.185
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1041.624,1039.509H1063.6l-.068.2h-21.747l-4.4,12.763h-.231Z",
    transform: "translate(-1027.963 -1038.381)",
    fill: "#14255e",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M1047.857,1091.957h25.32l.707-2.1h-25.321Z",
    transform: "translate(-1041.1 -1075.303)",
    fill: "#e6e7e8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M1029.065,1051.3h31.412l5.556-16.017h0a4.527,4.527,0,0,1,.053,3.1l-4.744,13.745a.914.914,0,0,1-.864.616h-31.412a.721.721,0,0,1-.721-.721h0A.721.721,0,0,1,1029.065,1051.3Z",
    transform: "translate(-1028.344 -1035.28)",
    fill: "#f1f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M1030.576,1051.3h-2.232v1.441h2.232a.914.914,0,0,0,.864-.616l4.744-13.745a4.526,4.526,0,0,0-.052-3.1h0Z",
    transform: "translate(-998.443 -1035.28)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1048.9,1097.129a.285.285,0,1,0,.286-.286A.286.286,0,0,0,1048.9,1097.129Z",
    transform: "translate(-1016.958 -1080.424)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M1069.115,1089.8h12.512a.594.594,0,0,0,.544-.355l.264-.6h-13.38l-.227.519A.314.314,0,0,0,1069.115,1089.8Z",
    transform: "translate(-1055.237 -1074.555)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1050.3,1095.334c.676,0,.676,1.441,0,1.441h7.622c-.84,0-.84-1.441,0-1.441Z",
    transform: "translate(-1025.79 -1079.317)",
    fill: "#999"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 2.797,
    height: 0.551,
    rx: 0.275,
    transform: "translate(26.651 16.523)",
    fill: "gray"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3650",
    "data-name": "Group 3650",
    transform: "translate(101.808 58.9)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166-2",
    "data-name": "Path 166",
    d: "M1796.427,1123.646h.928l1.57-81.053h-4.069Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#5f6169"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_167-2",
    "data-name": "Path 167",
    d: "M1794.857,1042.593h4.069l-.086,4.934-3.949-3.018Z",
    transform: "translate(-1794.857 -1042.593)",
    fill: "#031162",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3651",
    "data-name": "Group 3651",
    transform: "translate(28.174 58.9)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168-2",
    "data-name": "Path 168",
    d: "M1520.338,1123.646h.928l1.57-81.053h-4.068Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_169-2",
    "data-name": "Path 169",
    d: "M1518.768,1042.593h4.068l-.086,3.844-3.948-2.352Z",
    transform: "translate(-1518.768 -1042.593)",
    fill: "#031162",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    d: "M1493.2,1041.082h88.109a.864.864,0,0,0,.864-.864h0a.864.864,0,0,0-.864-.864H1493.2a.864.864,0,0,0-.864.864h0A.864.864,0,0,0,1493.2,1041.082Z",
    transform: "translate(-1471.214 -981.318)",
    fill: "#555"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649",
    transform: "translate(0 17.066)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 2.292,
    height: 49.992,
    transform: "translate(39.728 66.297)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M547.807,1112.847H522.815a24.494,24.494,0,0,1-13.652-16.1l-12.089-45.873a2.813,2.813,0,0,0-2.719-2.1h-8.386a2.151,2.151,0,0,0-1.093,0h0a2.154,2.154,0,0,0-1.534,2.631l12.093,45.886a26.673,26.673,0,0,0,25.775,19.862h26.6a2.153,2.153,0,1,0,0-4.307Z",
    transform: "translate(-483.269 -1048.703)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M546.143,1114.971H522.995c-6.59-2.964-13.565-8.307-15.5-15.635l-12.089-45.873a2.812,2.812,0,0,0-2.719-2.1H484.3a2.149,2.149,0,0,0-.979-.026,2.152,2.152,0,0,1,1.547-2.567h0a2.151,2.151,0,0,1,1.093,0h8.386a2.813,2.813,0,0,1,2.719,2.1l12.089,45.873a24.494,24.494,0,0,0,13.652,16.1H547.8a2.153,2.153,0,0,1,.441,4.261C548.034,1116.047,547.173,1114.971,546.143,1114.971Z",
    transform: "translate(-483.267 -1048.703)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M532.485,1381.947a29.415,29.415,0,0,1,22.5,0V1376.3c-6.514-2.517-13.6-3.583-22.5,0Z",
    transform: "translate(-502.938 -1259.059)",
    fill: "#222"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDesk);
export default __webpack_public_path__ + "static/media/NoDesk.b37f7b3fd362fc0611d7d6c9722d85ad.svg";
export { ForwardRef as ReactComponent };